import { BaseModel } from '../email-template/base-model.interface';
import BlockModel from '../email-template/block-model.interface';
import { NotificationInitVariables } from '../template/notifications-model.interface';

export interface RsaSearchFinalUrlModel extends BaseModel {
  variables?: { [key: string]: string } | RsaSearchFinalUrlVariables;
}

export interface RsaSearchFinalUrlVariables {
  Link: string;
}

export class RsaSearchFinalUrlInitVariables implements RsaSearchFinalUrlVariables {
  Link = '';
}

export class RsaSearchFinalUrlInitModel implements BlockModel {
  blockId: string = '';
  count: number = 0;
  name: string = '';
  variables: { [key: string]: string };
  notifications: NotificationInitVariables[];

  constructor() {
    const initVars = new RsaSearchFinalUrlInitVariables();
    this.variables = { ...initVars };
    this.notifications = [new NotificationInitVariables()];
  }
}
